import React from 'react'
import { useInView } from 'react-intersection-observer'

export interface IDetectReachBottomProps {
  onReachBottom: () => void
}

const DetectReachBottom = ({ onReachBottom }: IDetectReachBottomProps) => {
  const { ref: viewRef } = useInView({
    threshold: 0.5,
    onChange: (inView) => {
      if (inView) {
        onReachBottom()
      }
    },
  })

  return <div id='observable' ref={viewRef} />
}

export default DetectReachBottom
